export enum RequestPageType {
    MobilePage = 2,
    CommonPage = 1
}